import React, { useEffect } from 'react';
import HandHistoryCard from './HandHistoryCard';
import ExportButton from './ExportButton';
import { preloadCardImages } from './preloadCardImages';

// Example data
const exampleData = {
  actions: {
    preflop: [
      { player: 'UTG', action: 'fold' },
      { player: 'LJ', action: 'fold' },
      { player: 'CO', action: 'raise', amount: 2.5 },
      { player: 'BTN', action: 'fold' },
      { player: 'SB', action: 'fold' },
      { player: 'BB (Hero)', action: 'call', amount: 1.5 }
    ],
    flop: [
      { player: 'BB (Hero)', action: 'check' },
      { player: 'CO', action: 'bet', amount: 3 },
      { player: 'BB (Hero)', action: 'call', amount: 3 }
    ],
    turn: [
      { player: 'BB (Hero)', action: 'check' },
      { player: 'CO', action: 'check' }
    ],
    river: [
      { player: 'BB (Hero)', action: 'bet', amount: 7.5 },
      { player: 'CO', action: 'fold' }
    ]
  },
  gameInfo: {
    stakes: '$1/$2',
    gameType: 'NL Hold\'em'
  },
  heroInfo: {
    position: 'BB',
    hand: ['As', 'Kh'] // Ace of spades, King of hearts
  },
  boardCards: {
    flop: ['Jh', '7s', '2d'],
    turn: ['Td'],
    river: ['Ks']
  }
};

const ExampleUsage = () => {
  // Preload card images when component mounts
  useEffect(() => {
    preloadCardImages({
      heroCards: exampleData.heroInfo.hand,
      boardCards: exampleData.boardCards
    });
  }, []);

  return (
    <div className="p-4 max-w-md mx-auto">
      <h1 className="text-2xl font-bold mb-4">Hand History Formatter</h1>
      
      {/* Theme selector could be added here */}
      
      {/* Hand history card */}
      <div className="mb-4">
        <HandHistoryCard
          actions={exampleData.actions}
          theme="dark"
          gameInfo={exampleData.gameInfo}
          heroInfo={exampleData.heroInfo}
          boardCards={exampleData.boardCards}
        />
      </div>
      
      {/* Export button */}
      <div className="flex justify-center">
        <ExportButton
          actions={exampleData.actions}
          theme="dark"
          gameInfo={exampleData.gameInfo}
          heroInfo={exampleData.heroInfo}
          boardCards={exampleData.boardCards}
          buttonText="Download as Image"
        />
      </div>
    </div>
  );
};

export default ExampleUsage; 